import { Menu, MenuProps } from 'antd';
import { FC, useState } from 'react';
import styled from 'styled-components';

import { useSideMenuItems } from '../hooks/useSideMenuItems';

export const SideMenu: FC = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const { items, selectedKeys, openKeys: defaultOpenKeys } = useSideMenuItems();

  function setCollapsedTrue() {
    setCollapsed(true);
    setOpenKeys([]);
  }

  function setCollapsedFalse() {
    setCollapsed(false);
    setOpenKeys(defaultOpenKeys);
  }

  const handleOpenChange = (keys: string[]) => {
    setOpenKeys(keys);
  };

  return (
    <ASideMenu
      theme={'dark'}
      mode='inline'
      items={items as MenuProps['items']}
      inlineCollapsed={collapsed}
      selectedKeys={selectedKeys}
      openKeys={openKeys}
      onOpenChange={handleOpenChange}
      onMouseEnter={setCollapsedFalse}
      onMouseLeave={setCollapsedTrue}
    />
  );
};

const ASideMenu = styled(Menu)`
  left: 0 !important;
  z-index: 99 !important;
  max-width: 270px !important;
  position: absolute !important;
  background-color: #141414 !important;
  height: 100%;

  &.ant-menu-vertical {
    width: 48px;
  }

  & > .ant-menu-item {
    padding: 0 19px !important;
  }
  & > .ant-menu-submenu > .ant-menu-submenu-title {
    padding: 0 19px !important;
  }

  & svg {
    width: 14px;
    height: 14px;
  }

  &.ant-menu-inline-collapsed {
    & > .ant-menu-item {
      padding: 0 12px !important;
    }
    & > .ant-menu-submenu > .ant-menu-submenu-title {
      padding: 0 12px !important;
    }
  }
`;
